'use client'
import NavigateLeftIcon from '@/app/icons/navigate-left'
import NavigateRightIcon from '@/app/icons/navigate-right'
import { relativeUrl } from '@/util/url'
import { IGif } from '@giphy/js-types'
import { useRouter } from 'next/navigation'
import { useRelatedGifPagination } from './use-related-pagination'
type Props = { gif: IGif }
const DesktopPagination = ({ gif }: Props) => {
    const { next, prev } = useRelatedGifPagination(gif)
    const router = useRouter()
    return (
        <div className="flex items-center justify-end gap-1">
            <div
                className={`bg-giphyCharcoal flex h-[22px] w-[32px] items-center justify-center rounded-sm ${
                    !prev ? 'pointer-events-none bg-giphyCharcoal/30' : 'cursor-pointer'
                }`}
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    router.push(relativeUrl(prev.url))
                }}
            >
                <NavigateLeftIcon height={13} />
            </div>
            <div
                className={`bg-giphyCharcoal flex h-[22px] w-[32px] items-center justify-center rounded-sm ${
                    !next ? 'pointer-events-none bg-giphyCharcoal/30' : 'cursor-pointer'
                }`}
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    router.push(relativeUrl(next.url))
                }}
            >
                <NavigateRightIcon height={13} />
            </div>
        </div>
    )
}
export default DesktopPagination
